import { useState } from "react";
import { AuthPageLayout } from "./auth-page-layout";
import { Button, FormError, FormField, TextInput } from "@/components/ui";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    console.log("[workshop] Forgot password submitted:", { email });

    setTimeout(() => {
      setIsSubmitting(false);
      setSent(true);
    }, 1500);
  }

  return (
    <AuthPageLayout>
      <div className="flex flex-col gap-5">
        <h2
          className="text-2xl font-semibold text-primary"
          data-testid="forgot-heading"
        >
          Reset your password
        </h2>

        {sent ? (
          <div data-testid="forgot-success">
            <p className="text-[15px] leading-normal text-secondary">
              If an account exists for{" "}
              <span className="font-medium text-primary">{email}</span>,
              you&apos;ll receive a password reset email shortly.
            </p>
            <button
              type="button"
              onClick={() => console.log("[workshop] Navigate to login")}
              className="mt-6 inline-block text-[13px] font-semibold text-accent hover:underline"
              data-testid="back-to-login"
            >
              Back to sign in
            </button>
          </div>
        ) : (
          <>
            <p className="text-[15px] leading-normal text-secondary">
              Enter your email and we&apos;ll send you a link to reset your
              password.
            </p>

            <FormError
              message={error}
              className="mt-0"
              data-testid="forgot-error"
            />

            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-5"
              data-testid="forgot-form"
            >
              <FormField label="Email address" htmlFor="email">
                <TextInput
                  id="email"
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="h-12 rounded-xl text-sm px-4"
                  data-testid="forgot-email"
                />
              </FormField>

              <Button
                type="submit"
                variant="secondary"
                size="lg"
                disabled={isSubmitting}
                className="w-full liquid-glass-distortion shadow-glass border-glass-stroke-light font-semibold text-accent"
                data-testid="forgot-submit"
              >
                {isSubmitting ? "Sending..." : "Send reset link"}
              </Button>
            </form>

            <button
              type="button"
              onClick={() => console.log("[workshop] Navigate to login")}
              className="text-[13px] font-semibold text-accent hover:underline"
              data-testid="back-to-login"
            >
              Back to sign in
            </button>
          </>
        )}
      </div>
    </AuthPageLayout>
  );
}
